import { Stack } from '@chakra-ui/react';
import styles from './CbButtonStack.module.css';
export interface CbButtonStackProps<T> {
  options: {
    name: string;
    value: T;
  }[];
  value: T;
  onChange: (value: T) => void;
  disabled?: boolean;
}

// Forgive me, this really should be a styled radiogroup
export function CbButtonStack<T>({
  options,
  value,
  onChange,
  disabled = false
}: CbButtonStackProps<T>) {
  return <div className={styles.container} data-sentry-component="CbButtonStack" data-sentry-source-file="CbButtonStack.tsx">
      <Stack direction="row" data-sentry-element="Stack" data-sentry-source-file="CbButtonStack.tsx">
        {options.map(({
        name,
        value: thisValue
      }) => {
        return <button disabled={disabled} key={name} className={`${styles.button} ${thisValue === value ? styles.active : ''} ${disabled ? styles.disabled : ''}`} onClick={() => onChange(thisValue)}>
              {name}
            </button>;
      })}
      </Stack>
    </div>;
}